import styled from '@emotion/styled'

const FiltersAreaContainer = styled.section`
  position: relative;
  background-color: #f7f7f7;
  border-top: 1px solid grey;
  padding: 10px;
  padding-bottom: 15px;
  margin-bottom: 40px;
`

export default FiltersAreaContainer
